import React from 'react';
import { BarVisualizer, useVoiceAssistant, RoomContext } from '@livekit/components-react';
import { Box, Typography } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

/**
 * Wrapper interno que usa useVoiceAssistant (requiere RoomContext).
 */
function AgentVisualizerInner() {
  const { state, audioTrack } = useVoiceAssistant();

  const stateLabels = {
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    initializing: 'Iniciando...',
    listening: 'Escuchando',
    thinking: 'Pensando...',
    speaking: 'Hablando',
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0b0f14',
        gap: 3,
        position: 'relative',
      }}
    >
      <SmartToyIcon sx={{ fontSize: 48, color: 'rgba(255,255,255,0.15)' }} />

      <BarVisualizer
        state={state}
        trackRef={audioTrack}
        barCount={7}
        style={{ width: '60%', maxWidth: 280, height: 80 }}
      />

      <Typography
        variant="caption"
        sx={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '0.75rem',
          letterSpacing: 1,
          textTransform: 'uppercase',
        }}
      >
        {stateLabels[state] || state}
      </Typography>
    </Box>
  );
}

/**
 * Componente que renderiza un BarVisualizer animado para el agente de voz.
 * Provee RoomContext con la Room de livekit-client ya conectada.
 */
export default function AgentVisualizer({ room }) {
  if (!room) return null;

  return (
    <RoomContext.Provider value={room}>
      <AgentVisualizerInner />
    </RoomContext.Provider>
  );
}
